import { FC } from "react";
import { ReactComponent as OtherIcon } from "./Other.svg";
import style from "../ImportantInformation.module.scss";

export const Other: FC = () => {
  return (
    <li data-animation-direction="from-bottom" data-animation-delay="300">
      <div className="neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className={style.cardTitle}>
          <span className={style.cardIcon}>
            <OtherIcon style={{ width: 60, height: "auto" }} />
          </span>
          <h3>Other</h3>
        </div>

        <div className="info">
          <p className={style.cardText}>
            Dear guests, unfortunately, there will be no dedicated children's
            area at our wedding. We kindly suggest making arrangements for your
            children in advance, so you can fully enjoy the celebration. Thank
            you for your understanding!
          </p>
          <p className={style.cardText}>
            If you have any questions, our wonderful event coordinators will be
            happy to assist you.
          </p>
          <a
            href="https://www.instagram.com/alona.p__/"
            className="btn btn-primary reverse"
            target="_blank"
            rel="noreferrer"
          >
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            <i className="fab fa-instagram"></i>Contact Alona
          </a>
        </div>
      </div>
    </li>
  );
};
